import {Injectable} from "@angular/core";
import {environment} from "../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {Customer, CustomerBooking, CustomerInvoice, CustomerNotification} from "./Customer";

@Injectable({ providedIn: 'root' })
export class CustomerService {
  private apiV1: string = environment.apiV1;
  private baseRef: string = environment.origin;
  private serviceRef: string = environment.service.core;

  constructor(
    private httpClient: HttpClient,
  ) { }

  public getMe(authId: string): Observable<Customer> {
    return this.httpClient.get<Customer>(`${this.baseRef}${this.serviceRef}${this.apiV1}customers/me/${authId}`);
  }

  public getAllBookingsByCustomerId(customerId: string): Observable<CustomerBooking> {
    return this.httpClient.get<CustomerBooking>(`${this.baseRef}${this.serviceRef}${this.apiV1}customers/${customerId}/bookings`);
  }

  public getAllInvoicesByCustomerExternalId(externalId: string): Observable<CustomerInvoice> {
    return this.httpClient.get<CustomerInvoice>(`${this.baseRef}${this.serviceRef}${this.apiV1}customers/${externalId}/invoices`);
  }

  public getAllCustomerNotificationsByCustomerId(customerId: string): Observable<CustomerNotification[]> {
    return this.httpClient.get<CustomerNotification[]>(`${this.baseRef}${this.serviceRef}${this.apiV1}customers/${customerId}/notifications`);
  }

  public updateOne(customerId: string, customer: Customer): Observable<Customer> {
    return this.httpClient.put<Customer>(`${this.baseRef}${this.serviceRef}${this.apiV1}customers/${customerId}`, customer);
  }

  public exportMe(customerId: string) {
    return this.httpClient.get(`${this.baseRef}${this.serviceRef}${this.apiV1}customers/${customerId}/export`, { responseType: 'blob' });
  }

  public disableMe(customerId: string) {
    return this.httpClient.get(`${this.baseRef}${this.serviceRef}${this.apiV1}customers/${customerId}/disable`);
  }

  public updatePassword(authId: string): Promise<boolean> {
    return new Promise<boolean>(((resolve) => {
      return this.httpClient.get<void>(`${this.baseRef}${this.serviceRef}${this.apiV1}customers/${authId}/change-password`)
        .subscribe(() => {
          resolve(true);
        });
    }));
  }

}
